import { injectTranslate } from '@core/i18n-legacy';
import { cellTransformFullDate, textCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const closedAtColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.ClosedAt,
  label: injectTranslate()('app.offers.table.close_date'),
  visible: false,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 190,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('closedAt', cellTransformFullDate),
}));
